import config from '../config';

export const Auth0ChangePassword = (email?: string): Promise<any> => {
  const domain = config.AUTH0_DOMAIN || '';
  const clientId = config.AUTH0_CLIENT_ID || '';
  const connection = config.AUTH0_CONNECTION || '';

  const requestChangePassword = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      client_id: clientId,
      email: email,
      connection: connection,
    }),
  };
  return fetch('https://' + domain + '/dbconnections/change_password', requestChangePassword);
};
